import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutService } from '../../../../shared/services/layout.service';
import { NavService } from '../../../../shared/services/nav.service';
import { FooterComponent } from '../../footer/footer.component';
import { HeaderComponent } from '../../header/header.component';
import { SidebarComponent } from '../../sidebar/sidebar.component';
import {GeneralService} from "../../../../core/services/general.service";

@Component({
  selector: 'app-content',
  standalone: true,
   imports : [HeaderComponent,SidebarComponent,FooterComponent,
    CommonModule,RouterModule],
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss']
})

export class ContentComponent {

  alertShow = false;
  typeAlert = "alert-secondary";
  messageAlert = "";

  public innerWidth : number;
  
  constructor(
    public navService: NavService, 
    public layoutServices : LayoutService,
    private generalData: GeneralService){
    // Suscríbete al servicio para controlar la visibilidad del toast
      this.generalData.toastVisible$.subscribe((data) => {
        console.log(data);
        this.typeAlert = (data.type == "success") ?  "alert-success" : "alert-danger";
        this.messageAlert = data.message;
        setTimeout(() => this.alertClose(), data._timer);
        this.alertShow = true;
      });
    }

  get layoutClass() {
    return (
      this.layoutServices.config.settings.sidebar_type + '' 
    );
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    if (window.innerWidth < 1200) {
      this.layoutServices.config.settings.sidebar_type = "page-wrapper compact-wrapper";
    }
  }

  showAlert(){
    this.alertShow = true;
  }

  alertClose(){
    this.alertShow = false;
  }

}
